import {gql} from 'apollo-angular';
import {baseResponseGraphqlField} from '../../../base.graphql';

export const citideliveryProcedureField = `
id
stepUniqueId
stepName
stepDecision
stepTimeInYear
stepTimeInMonths
stepTimeInWeeks
stepTimeInDays
stepTimeInHours
stepTimeInMinutes
stepTimeInSec
stepDesignation {
  id
  designationUniqueId
  designationShortForm
  designationName
}
`;

export const GET_CITIZEN_SERVICES_DELIVERY_PROCEDURE_STEPS = gql`
query CitizenGetServicesDeliveryProcedureSteps($serviceUniqueId:String){
    citizenGetServicesDeliveryProcedureSteps(serviceUniqueId:$serviceUniqueId){
    ${baseResponseGraphqlField}
    data {
      ${citideliveryProcedureField}
    }
  }
}
`;
